var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPiggyBankWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:current;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103.41,63.36a24.72,24.72,0,0,0-6.8-9.21l-.78-9.33-8,4.19A32.57,32.57,0,0,0,76.38,47C62.9,47,51.59,55,48.51,65.77a6.05,6.05,0,0,0-8.34,5.58v1.16l4.34,0V71.35a1.7,1.7,0,0,1,1.7-1.7,1.72,1.72,0,0,1,1.5.89c0,.39,0,.78,0,1.17,0,7.62,4,14.43,10.28,19l1.27,10.18h9.3l.91-5.13a33.64,33.64,0,0,0,6.95.73,33,33,0,0,0,6.35-.61l.63,5h9.3L94.42,91a25.25,25.25,0,0,0,9-10.91l6.42-1.75V65.12ZM66.4,58V53.69H81.84V58ZM91.1,68a2.17,2.17,0,1,1,2.17-2.17A2.17,2.17,0,0,1,91.1,68Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiggyBankWhite);
export default __webpack_public_path__ + "static/media/piggy-bank-white.48c702405d5f8657a40dc78dee0f1752.svg";
export { ForwardRef as ReactComponent };